import { render, staticRenderFns } from "./BasicInOut.vue?vue&type=template&id=2ec1153e&scoped=true"
import script from "./BasicInOut.vue?vue&type=script&lang=js"
export * from "./BasicInOut.vue?vue&type=script&lang=js"
import style0 from "./BasicInOut.vue?vue&type=style&index=0&id=2ec1153e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1153e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec1153e')) {
      api.createRecord('2ec1153e', component.options)
    } else {
      api.reload('2ec1153e', component.options)
    }
    module.hot.accept("./BasicInOut.vue?vue&type=template&id=2ec1153e&scoped=true", function () {
      api.rerender('2ec1153e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/operations/BasicInOut.vue"
export default component.exports